import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { RowActions } from '../../../../../../components'
import { IconPaths } from '../../../../../../../_metronic/helpers'
import { FaturaProfissionalDtoView } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  fatura: FaturaProfissionalDtoView
}

/** Ação única da linha: ver os itens (atendimentos) da fatura — sempre visível, sem menu. */
export const FaturaProfissionalActionsCell: FC<IProps> = ({ fatura }) => {
  const navigate = useNavigate()
  const { t } = useT()
  const { mesSigla, ano } = fatura.mesAno ?? {}
  const nome = [fatura.empresa?.nomeFantasia, mesSigla && ano && `${mesSigla}/${ano}`]
    .filter(Boolean)
    .join(' ')

  return (
    <RowActions
      itemName={`fatura ${nome || fatura.id}`}
      primaryAction={{
        label: t('dropdown_item.visualizar_itens'),
        onClick: () => navigate(`atendimentos/${fatura.id}`),
        icon: IconPaths.Search,
      }}
    />
  )
}
